import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initTelemetry } from './lib/telemetry';
import './styles.css';

// MCIP-28 — self-telemetry hooks (uncaught errors, rejections, breadcrumbs)
// go in BEFORE first render so even a crash-on-boot is recorded.
initTelemetry();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
